module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_8023.1a1dbfd4.png";